import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // In a real deployment this is where you'd forward to an error-tracking
    // service (Sentry, etc.) instead of just the console.
    console.error("Unhandled UI error:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
            <FiAlertTriangle className="h-6 w-6" />
          </div>
          <h1 className="mt-4 text-xl font-semibold text-slate-900">Something went wrong</h1>
          <p className="mt-1.5 max-w-sm text-sm text-slate-500">
            We hit an unexpected error. Try going back to your dashboard — if it keeps
            happening, let us know what you were doing when it occurred.
          </p>
          <button
            onClick={this.handleReload}
            className="mt-6 inline-flex items-center justify-center rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700"
          >
            Back to dashboard
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
